// extracted by mini-css-extract-plugin
module.exports = {"info":"CustomerModule_info__3e_1W","main":"CustomerModule_main__2paT2","tableSmall":"CustomerModule_tableSmall__2Qy1J","userPhoto":"CustomerModule_userPhoto__1x1so"};